export const OFFER_STORAGE_KEY = 'stardecide::offer-gate-state::v1';

type OfferGateAction = 'accepted' | 'skipped';
export type OfferGateReason = 'signup' | 'reactivation' | 'upsell';

export type OfferGateState = {
  pending: boolean;
  reason: OfferGateReason;
  createdAt: string;
  lastAction?: OfferGateAction;
  resolvedAt?: string;
};

function isBrowser() {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

function readState(): OfferGateState | null {
  if (!isBrowser()) {
    return null;
  }
  try {
    const raw = window.localStorage.getItem(OFFER_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    return JSON.parse(raw) as OfferGateState;
  } catch (error) {
    console.warn('[OfferGate] Failed to parse stored state', error);
    return null;
  }
}

function writeState(state: OfferGateState) {
  if (!isBrowser()) {
    return;
  }
  try {
    window.localStorage.setItem(OFFER_STORAGE_KEY, JSON.stringify(state));
  } catch (error) {
    console.warn('[OfferGate] Failed to persist state', error);
  }
}

export function getOfferGateState() {
  return readState();
}

export function markOfferPending(reason: OfferGateReason = 'signup') {
  if (!isBrowser()) {
    return;
  }
  const nextState: OfferGateState = {
    pending: true,
    reason,
    createdAt: new Date().toISOString(),
  };
  writeState(nextState);
}

export function resolveOfferGate(action: OfferGateAction) {
  if (!isBrowser()) {
    return;
  }
  const existing = readState();
  if (!existing) {
    return;
  }
  const nextState: OfferGateState = {
    ...existing,
    pending: false,
    lastAction: action,
    resolvedAt: new Date().toISOString(),
  };
  writeState(nextState);
}
